export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9220.90a56423.jpg";